module.exports = __webpack_public_path__ + "img/back_faq_1.31a920ae.png";